import React, { useEffect, useState } from 'react';
import useApiStable from '../../utils/useApiStable';

function minutesToHours(minutes) {
  return (minutes / 60).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

function formatDateTime(dateTimeStr) {
  const d = new Date(dateTimeStr);
  return d.toLocaleDateString('de-DE') + ' ' + d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
}

function WorkDutyAccountCard() {
  const api = useApiStable();
  const [account, setAccount] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/workduty/account/me')
      .then(setAccount)
      .catch(err => setError(err.message || 'Fehler beim Laden des Arbeitsdienst-Kontos'));
  }, []); // eslint-disable-line

  if (error) {
    return (
      <div style={{ marginBottom: '30px', paddingBottom: '20px', borderBottom: '1px solid #ddd' }}>
        <h3 style={{ fontSize: '1.2em', marginBottom: '15px', color: '#333' }}>Arbeitsdienst</h3>
        <div style={{ color: '#c62828', fontSize: '0.85em' }}>{error}</div>
      </div>
    );
  }

  if (!account) {
    return null;
  }

  return (
    <div style={{ marginBottom: '30px', paddingBottom: '20px', borderBottom: '1px solid #ddd' }}>
      <h3 style={{ fontSize: '1.2em', marginBottom: '15px', color: '#333' }}>Arbeitsdienst</h3>
      <p style={{ fontSize: '1.1em', marginBottom: '12px' }}>
        Aktueller Kontostand: <strong>{minutesToHours(account.balanceMinutes)} Stunden</strong>
      </p>
      {account.transactions.length > 0 && (
        <div>
          <p style={{ fontSize: '0.9em', color: '#666', marginBottom: '8px' }}>Letzte Buchungen:</p>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '0.85em' }}>
            {account.transactions.slice(0, 10).map(t => (
              <li key={t.id} style={{ padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
                <span style={{ color: t.deltaMinutes >= 0 ? '#2e7d32' : '#c62828', fontWeight: 'bold' }}>
                  {t.deltaMinutes >= 0 ? '+' : ''}{minutesToHours(t.deltaMinutes)} h
                </span>
                {' '}— {formatDateTime(t.createdAt)}
                {t.comment && <span style={{ color: '#666' }}> ({t.comment})</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default WorkDutyAccountCard;
